import { Link, useNavigate, useParams } from 'react-router-dom';
import type { GetUserPostsQuery } from '../../gql/graphql';
import { formatDate } from '../../helpers/dateConverters';
import type { TextBlock } from '../../interfaces/textEditor.interface';
import ModerationBanner from './ModerationBanner';
import './user-posts-component.scss';

export type UserPostListItem = NonNullable<
  GetUserPostsQuery['getUserPosts']
>[number];

interface PostsProps {
  posts: UserPostListItem[];
}

export default function Posts(props: PostsProps) {
  const { posts } = props;
  const params = useParams();
  const { username } = params;
  const navigate = useNavigate();
  const getTitle = (textBlocks: TextBlock[]) => {
    const headingBlock = textBlocks?.find(
      (block) => block.type === 'Heading' && block.data?.level === 1,
    );
    return headingBlock
      ? headingBlock.data?.header
      : 'Post Title not saved as H1';
  };
  const reversedPosts = [...posts].reverse();

  return (
    <div className="Grid">
      {reversedPosts.map((post: any) => (
        <div key={post.id}>
          {post.moderation && (
            <ModerationBanner
              meta={post.moderation}
              onEdit={
                post.moderation.status === 'hidden_pending_rewrite'
                  ? () => navigate(`/post/${post.id}/edit-rewrite`)
                  : undefined
              }
            />
          )}
          <Link style={{ textDecoration: 'none' }} to={`/post/${post.id}`}>
            <div className="card">
              <div className="card-content">
                <p>{getTitle(post.textBlocks)}</p>
                <p>Published on: {formatDate(post.createdAt as Date)}</p>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}
